module.exports = __webpack_public_path__ + "img/loadmodel.bc3c9101.gif";